var _path, _rect, _rect2, _g, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6, _path5, _rect7, _rect8, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInteriorBackOverlay = function SvgInteriorBackOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-ceiling"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-ceiling-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M0.619138 34.9657L0.0219727 34.7314V0H724V34.7314C675.865 51.9503 620.458 82.6705 598.771 95.8782C581.161 105.662 531.102 143.654 508.274 161.428C498.491 168.863 489.522 173.657 486.261 175.124C484.305 176.298 481.859 176.266 480.88 176.103L474.521 175.124C466.303 173.559 442.725 170.559 431.963 169.254C414.744 167.298 385.002 165.83 372.284 165.341C347.238 164.558 316.518 166.972 304.288 168.276C289.418 169.059 266.133 172.515 256.349 174.146C250.088 175.32 244.609 175.94 242.652 176.103C239.522 176.103 236.13 174.472 234.826 173.657C230.521 172.092 216.726 162.243 210.367 157.514C114.494 79.6474 39.4396 50.198 0.619138 34.9657Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-ceiling-point",
    className: "svg-interior-point"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 345.379,
    y: 71.4196,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-back-ceiling-text",
    x: 362,
    y: 92.8159,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6969,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 345.379,
    y: 71.4196,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    stroke: "white",
    strokeWidth: 1.9567
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-backSeats"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interior-back-backSeats-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.947 177.08C234.826 178.548 208.41 177.08 199.116 177.08C192.463 177.471 190.8 191.918 190.8 199.093C190.409 205.746 191.615 213.605 192.267 216.703C182.484 218.269 175.146 221.595 172.7 223.552C165.852 228.443 160.797 237.249 159.004 241.162C158.025 243.119 154.112 252.902 153.623 258.283C153.069 264.378 151.177 266.273 150.198 267.577C139.926 276.872 122.805 293.993 114.978 303.287C105.194 315.027 99.6504 325.626 98.3459 329.702C94.4325 339.095 95.737 353.183 96.8784 359.053C98.8351 371.184 104.542 386.936 107.151 393.295C112.63 407.383 121.5 417.428 125.251 420.689C133.469 429.69 145.307 430.309 150.198 429.494V431.451C145.111 431.842 139.274 433.897 136.991 434.875C133.469 435.658 126.066 440.093 122.805 442.213C118.5 444.952 114.489 446.289 113.021 446.615C109.89 447.398 104.542 446.941 102.259 446.615C88.1711 443.876 74.2133 446.778 68.9955 448.572C63.9081 450.529 59.7012 453.301 58.2336 454.442V454.931C62.147 467.063 66.0604 485.423 67.528 493.087C67.9193 499.348 69.9738 516.893 70.9522 524.883C71.3435 528.796 74.0503 534.993 75.3547 537.602C75.8439 539.069 89.3777 565.974 96.3892 579.181H293.526V578.692L297.929 523.905C297.929 522.731 298.255 521.785 298.418 521.459L303.31 513.143C306.049 508.838 308.691 499.935 309.669 496.022L313.093 477.433C314.267 472.346 313.909 468.791 313.583 467.65C313.191 465.693 311.789 461.943 311.137 460.312C310.354 459.138 309.18 454.279 308.691 451.996C307.517 448.083 305.919 446.452 305.267 446.126C304.484 445.343 302.006 445.474 300.864 445.637C296.951 446.811 294.342 446.778 293.526 446.615C291.57 446.224 290.755 444.495 290.591 443.68L289.613 439.278C288.83 436.147 286.026 434.06 284.721 433.407C281.199 431.451 275.427 430.962 272.981 430.962V429.494H281.786C285.308 429.494 288.798 426.885 290.102 425.581C295.972 419.319 300.701 410.253 302.332 406.503C304.68 402.198 309.506 389.382 311.626 383.512L317.985 361.499C321.899 348.585 321.246 333.942 320.431 328.235C318.474 317.277 313.093 306.059 310.648 301.82L302.821 287.144C299.69 281.666 294.342 272.143 292.059 268.067C291.668 267.284 291.244 263.827 291.081 262.196C290.298 253.978 288.146 245.401 287.167 242.14C283.254 231.965 278.362 226.487 276.405 225.019C277.579 223.062 276.568 221.921 275.916 221.595L264.176 217.682C263.785 217.682 263.361 218.008 263.198 218.171L257.328 216.703C258.502 210.833 258.469 196.647 258.306 190.288C258.306 184.418 257.001 180.667 256.349 179.526C255.175 177.569 252.762 177.08 251.947 177.08Z",
    fill: "#FFA928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.093 521.948C427.267 545.82 429.843 570.05 430.984 579.181H627.633C640.84 555.701 649.482 535.808 653.07 526.84C654.048 510.208 656.82 489.663 658.451 481.347C659.429 476.455 663.668 461.617 665.788 454.442C658.94 449.061 649.645 446.778 645.732 446.126C638.297 444.952 623.393 446.289 616.871 447.104C609.435 447.104 603.663 443.843 601.706 442.213C597.793 439.473 589.966 435.853 586.542 434.386C581.454 432.038 571.704 431.125 567.464 430.962V429.005C579.204 429.983 580.183 429.168 584.096 429.005C589.183 428.614 595.673 423.624 598.282 421.178C606.5 412.96 612.142 403.405 613.936 399.654C619.023 389.871 622.578 378.294 623.719 373.728C624.698 370.793 627.633 359.053 628.122 352.694C628.513 343.693 627.959 338.182 627.633 336.551C626.85 332.638 625.024 328.072 624.208 326.278C620.686 317.277 611.653 306.222 607.576 301.82C606.598 300.352 594.695 287.797 588.499 281.763L575.291 269.045C572.16 266.305 570.399 258.772 569.91 255.348C567.953 247.13 563.551 238.553 561.594 235.292C558.072 227.856 550.343 222.736 546.919 221.106C543.788 219.149 535.505 217.355 531.754 216.703C532.537 214.747 533.059 208.061 533.222 204.963C534.005 194.006 531.591 184.744 530.287 181.483C529.504 179.526 527.352 178.058 526.373 177.569C525.591 177.178 522.786 177.08 521.482 177.08C507.393 177.863 491.479 177.732 485.283 177.569C479.413 177.178 473.706 177.08 471.586 177.08C468.847 177.08 467.509 179.689 467.183 180.993C464.835 186.081 465.879 206.92 466.694 216.703C464.737 217.095 461.966 217.845 460.824 218.171C460.433 217.779 460.009 217.682 459.846 217.682L448.595 221.595C446.638 222.378 447.127 224.204 447.616 225.019C442.529 228.933 438.322 238.716 436.855 243.119C434.898 248.989 433.756 256.326 433.43 259.261C433.039 265.914 431.963 268.556 431.474 269.045L412.885 302.309C404.667 317.571 402.938 330.192 403.102 334.594C402.319 345.16 405.71 360.194 407.504 366.391C408.678 371.869 412.885 384.327 414.842 389.871C417.581 397.306 422.505 407.644 424.625 411.884C426.582 416.58 431.963 423.298 434.409 426.07C436.365 428.418 440.768 429.331 442.725 429.494H451.041V430.962C445.953 431.353 442.725 432.103 441.746 432.429C436.659 433.603 434.735 437.81 434.409 439.767L432.941 444.658C432.158 446.615 429.354 446.778 428.049 446.615L420.712 445.637C418.755 445.637 417.288 447.594 416.798 448.572C415.624 450.529 414.679 454.605 414.353 456.399L410.928 465.693C410.146 468.041 410.276 471.237 410.439 472.541C413.178 488.586 414.842 498.957 416.798 503.849C417.777 508.251 423.484 517.708 426.093 521.948Z",
    fill: "#FFA928"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-backSeats-point",
    className: "svg-interior-point"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 504.85,
    y: 329.702,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-back-backSeats-text",
    x: 521.5,
    y: 351.099,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6969,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 504.85,
    y: 329.702,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    stroke: "white",
    strokeWidth: 1.9567
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-coverRightPillar-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M92.4759 130.12C70.1696 118.38 21.5456 101.422 0.0219727 94.4105V59.1899C54.8095 77.1916 100.466 100.933 116.445 110.553C140.317 123.076 176.614 148.709 191.778 159.96C194.126 161.525 193.735 162.243 193.246 162.406L167.32 185.397C157.927 193.615 145.796 210.671 140.904 218.172C138.165 222.868 131.936 230.89 129.164 234.314C126.816 237.445 119.217 242.956 115.467 245.565L127.696 222.085L136.991 205.453C140.415 198.605 146.122 191.756 148.242 188.821C155.09 180.505 155.579 178.059 156.069 176.103C156.46 170.233 146.448 161.917 141.393 158.492C126.229 147.241 102.912 135.338 92.4759 130.12Z",
    fill: "#FFA928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-coverLeftPillar-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M626.165 100.281C643.384 90.4974 698.563 68.1585 724 58.2119V86.584C716.564 87.758 673.615 105.01 653.07 113.489C635.29 120.826 601.706 139.741 587.031 149.198C573.334 158.982 567.301 165.993 565.997 168.276C564.04 170.624 563.877 174.472 564.04 176.103C564.04 177.668 566.975 181.973 568.442 183.93C572.747 189.017 579.041 197.79 581.65 201.54C585.172 207.019 595.51 222.411 600.239 229.423L608.555 246.055C603.076 242.141 597.793 237.25 595.836 235.293C593.488 232.945 587.031 223.879 584.096 219.639C579.791 212.595 570.236 200.072 565.997 194.692C559.344 186.082 538.44 168.602 528.819 160.939L547.897 147.731C576.269 127.185 609.533 109.086 626.165 100.281Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-coverBackLeftDoor"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-coverBackLeftDoor-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M614.425 225.021L600.239 229.424L612.958 253.882C616.48 259.361 616.708 275.732 616.382 283.233L614.914 303.778C614.914 307.691 617.197 313.235 618.338 315.518C622.252 321.78 623.882 325.302 624.209 326.28C628.122 335.085 628.122 340.466 628.122 341.934C632.035 349.271 641.493 376.176 645.732 388.894C649.646 401.026 657.799 435.692 661.386 451.509C664.517 453.465 665.625 454.281 665.788 454.444L671.169 439.769C680.17 415.505 694.813 399.982 701.009 395.254C709.618 388.21 719.924 383.84 724 382.535V270.025L720.576 268.558L680.571 254.608L648.178 242.142C627.046 234.707 616.871 227.63 614.425 225.021Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-coverBackLeftDoor-point",
    className: "svg-interior-point"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 659.184,
    y: 301.332,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-back-coverBackLeftDoor-text",
    x: 675.8,
    y: 322.729,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6969,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 659.184,
    y: 301.332,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    stroke: "white",
    strokeWidth: 1.9567
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-coverBackRightDoor"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-coverBackRightDoor-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M113.133 221.969C116.068 224.415 122.864 229.405 123.647 229.796L113.488 249.445C108.401 258.446 107.455 266.24 107.618 269.012C107.227 278.796 108.434 293.96 109.086 300.319C109.869 305.798 108.108 311.081 107.129 313.038C104.781 316.56 100.933 323.963 99.3024 327.224C96.563 334.268 95.8782 339.943 95.8782 341.899C86.486 363.423 79.2462 385.762 76.8004 394.241C73.6697 402.459 66.0385 435.821 62.6143 451.474L58.2118 454.409L54.7875 444.626L53.32 441.202C45.4932 418.895 31.3072 401.579 23.9695 396.198C14.6752 388.371 4.23951 383.479 0 382.501V269.991L27.5157 259.927L55.627 250.323C76.8355 241.711 91.4921 236.095 96.3839 233.812C104.602 229.507 110.687 224.252 113.133 221.969Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-back-coverBackRightDoor-point",
    className: "svg-interior-point"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5378,
    y: 301.337,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-back-coverBackRightDoor-text",
    x: 46,
    y: 322.733,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6969,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5378,
    y: 301.337,
    width: 33.2639,
    height: 33.2639,
    rx: 16.6319,
    stroke: "white",
    strokeWidth: 1.9567
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-passengerSeat-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M29.3724 401.123C17.1431 389.383 5.40289 383.839 0.0219727 382.534V579.182H96.3893L84.6491 556.191C80.7357 549.147 75.1918 536.95 72.909 531.732C71.7349 528.602 71.1153 525.862 70.9523 524.884C69.3869 507.665 66.7127 489.989 65.5713 483.304C62.4406 467.259 58.0707 453.791 56.277 449.062C53.5376 440.452 47.3088 427.538 44.5368 422.157C36.71 409.243 31.1661 402.753 29.3724 401.123Z",
    fill: "#FFA928"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "interior-back-driverSeat-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M689.758 406.504C701.498 392.416 717.477 384.654 724 382.534V579.182H627.633L633.747 567.931L639.862 556.191L650.134 534.178C652.091 529.776 653.07 526.841 653.07 526.841L654.537 514.122C654.928 499.251 658.94 479.88 660.896 472.053C663.244 461.878 668.397 447.268 670.68 441.235C676.061 426.071 685.355 412.048 689.758 406.504Z",
    fill: "#FFA928"
  })));
};
export default SvgInteriorBackOverlay;